<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>保险管理系统</el-breadcrumb-item>
        <el-breadcrumb-item>保险申请</el-breadcrumb-item>
        <el-breadcrumb-item>查看详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="my-container box-shadow" v-loading="dataLoading">
      <div style="padding: 20px; border-bottom: 1px solid #dbdbdb">
        <div class="my-title">保险申请详情</div>
        <el-button size="small" @click="showFeedbackDialog" type="primary" style="float: right" v-if="detail.applyBrief.status == '待反馈'"> 反馈客户保险金额 </el-button>

        <el-button size="small" @click="linkToFeedbackPage" type="primary" style="float: right" v-if="detail.applyBrief.status == '未投保'"> 投保反馈 </el-button>
        <div style="clear: both"></div>
      </div>

      <div class="main-info">
        <div class="info-item">
          <div class="my-row">
            <div class="text">申请情况</div>
            <div class="text">{{ detail.applyBrief.status }}</div>
          </div>

          <div class="my-row">
            <div class="text">保险类型</div>
            <div class="text">汽车保险</div>
          </div>

          <div class="my-row">
            <div class="text">申请日期</div>
            <div class="text">{{ detail.applyBrief.applyTime | formatDateByCN }}</div>
          </div>
        </div>

        <div class="gap">
          <div>投保人信息</div>
          <hr />
        </div>

        <!--投保人信息-->
        <div class="info-item">
          <div class="my-row">
            <div class="text">车牌号</div>
            <div class="text">{{ detail.applyBrief.plateNumber }}</div>
          </div>

          <div class="my-row">
            <div class="text">购车价格</div>
            <div class="text">{{ detail.applyBrief.buyCarPrice }}元</div>
          </div>

          <div class="my-row">
            <div class="text">购车时间</div>
            <div class="text">{{ detail.applyBrief.buyCarDate }}</div>
          </div>

          <div class="my-row">
            <div class="text">投保城市</div>
            <div class="text">{{ detail.applyBrief.city }}</div>
          </div>
        </div>

        <div v-if="detail.applyBrief.status == '未投保'">
          <div class="gap">
            <div>反馈保险</div>
            <hr />
          </div>

          <!--反馈保险-->
          <div class="info-item">
            <div class="my-row">
              <div class="text">保险预报价</div>
              <div class="text">{{ detail.applyReturnInfo.price }}</div>
            </div>

            <div class="my-row">
              <div class="text">投保年限</div>
              <div class="text">{{ detail.applyReturnInfo.yearNo }}</div>
            </div>

            <div class="my-row">
              <div class="text">保险专员电话</div>
              <div class="text">{{ detail.applyReturnInfo.tel }}</div>
            </div>
          </div>
        </div>

        <div v-if="detail.applyBrief.status == '已投保'">
          <div class="gap">
            <div>投保信息</div>
            <hr />
          </div>

          <!--投保信息-->
          <div class="info-item">
            <div class="my-row">
              <div class="text">保险金额</div>
              <div class="text">{{ detail.returnInfo.price }}元</div>
            </div>

            <div class="my-row">
              <div class="text">投保年限</div>
              <div class="text">{{ detail.returnInfo.yearNo }}年</div>
            </div>

            <div class="my-row">
              <div class="text">保单号</div>
              <div class="text">{{ detail.returnInfo.cno == "" ? "未填写" : detail.returnInfo.cno }}</div>
            </div>
          </div>

          <div class="gap">
            <div>电子保单</div>
            <hr />
          </div>

          <!--电子保单-->
          <div class="info-item">
            <el-button size="small" @click="showPDF" type="primary" style="margin-top: 20px; margin-left: 195px"> 查看电子保单 </el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="反馈客户保险金额" :visible.sync="dialogFormVisible" style="text-align: center; color: #007373">
      <el-form id="form" style="width: 400px; margin: auto" :model="form" :rules="rules" ref="form">
        <el-form-item label="保险金额：" prop="amount">
          <el-input v-model="form.amount" size="small" placeholder="请输入保险金额" style="float: left; width: 250px" clearable> </el-input>
        </el-form-item>

        <el-form-item label="投保年限：" prop="year">
          <el-input v-model="form.year" size="small" placeholder="请输入投保年限" style="float: left; width: 250px" clearable> </el-input>
        </el-form-item>

        <el-form-item label="保险专员电话：" prop="tel">
          <el-input v-model="form.tel" size="small" placeholder="请输入保险专员电话" style="float: left; width: 250px" clearable> </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" style="margin: 50px auto auto">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var yearValid = (rule, value, callback) => {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error("请输入正整数"));
      } else {
        if (value < 0 || value >= 50) {
          callback(new Error("投保年限不能大于50年"));
        } else {
          callback();
        }
      }
    };

    var phoneValid = (rule, value, callback) => {
      const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value) && value != "") {
          callback(new Error("请输入正确的电话号码"));
        } else {
          callback();
        }
      }
    };

    var moneyValid = (rule, value, callback) => {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error("请输入正整数"));
      } else {
        if (value > 100000000) {
          callback(new Error("投保金额不能大于1亿"));
        } else {
          callback();
        }
      }
    };

    return {
      dialogFormVisible: false,
      dataLoading: false,
      form: {
        tel: "",
        amount: "",
        year: "",
      },
      detail: {
        applyBrief: {
          status: "",
        },
      },
      rules: {
        amount: [
          { required: true, message: "请输入保险金额", trigger: "blur" },
          { validator: moneyValid, trigger: "blur" },
        ],
        year: [
          { required: true, message: "请输入投保年限", trigger: "blur" },
          { validator: yearValid, trigger: "blur" },
        ],
        tel: [
          { required: true, message: "请输入保险专员电话", trigger: "blur" },
          { validator: phoneValid, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.dataLoading = true;
      this.$http({
        url: global.apiUrl + "/carInsurance/apply/detail",
        methods: "GET",
        params: {
          id: this.$route.query.id,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.dataLoading = false;
            this.detail = res.body.data;
          } else {
            this.dataLoading = false;
          }
        })
        .catch(err => {
          this.dataLoading = false;

          console.error(err);
        });
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.feedback2User();
        } else {
          this.$message({
            message: "请确认信息填写无误再提交！",
            type: "warning",
          });
          return false;
        }
      });
    },
    /**
     * 反馈申请信息
     */
    feedback2User() {
      const bodyParams = Object.assign(
        {},
        {
          id: this.$route.query.id,
          price: this.form.amount,
          tel: this.form.tel,
          yearNo: this.form.year,
        }
      );
      this.$http({
        url: global.apiUrl + "/carInsurance/apply/return",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.dialogFormVisible = false;
            this.loadData();
            this.$message({
              message: "反馈申请成功",
              type: "success",
            });
          } else {
            this.formLoading = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showFeedbackDialog() {
      this.dialogFormVisible = true;
    },
    linkToFeedbackPage() {
      const id = this.$route.query.id;
      this.$router.push({
        name: "carInsuranceFeedback",
        query: {
          id: id,
        },
      });
    },
    showPDF() {
      window.open(this.detail.returnInfo.pdfUrl, "_blank");
    },
  },
  filters: {
    /**
     * 格式化为月份 2019年1月
     */
    formatDateByCN(val) {
      if (val) {
        var date = new Date(val);
        return date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日";
      }
      return val;
    },
  },
};
</script>
<style>
#form .el-form-item__error {
  left: 135px;
}

.el-dialog__title {
  color: #007373;
}

#form .el-form-item__label {
  width: 130px;
}

.my-container {
  min-height: 500px;
  margin-top: 30px;
}

.my-title {
  float: left;
  height: 32px;
  line-height: 32px;
  font-size: 22px;
}

.main-info {
  padding: 0 0 30px 30px;
}

.clear-both {
  clear: both;
}

.my-row {
  margin-left: 160px;
  padding: 30px 0;
}

.my-row .text {
  float: left;
}

.my-row .text:first-child {
  color: #d2d2d2;
  width: 100px;
  text-align: right;
}

.my-row .text:last-child {
  margin-left: 40px;
}

.gap {
  position: relative;
  margin-top: 30px;
  margin-left: 40px;
}

.gap hr {
  height: 2px;
  border: none;
  border-top: 2px solid #dbdbdb;
}

.gap div {
  position: absolute;
  width: 90px;
  text-align: right;
  top: -11px;
  background: #fff;
  padding-right: 20px;
  font-size: 17px;
  font-weight: bold;
  color: #54b153;
}

.my-img {
  width: 300px;
  margin: 20px 0 0 153px;
  border: 1px solid #dbdbdb;
}
</style>
